import HeroSection from "../HeroSection";
import Footer from "../Footer";
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';
// import LoadingBar from "../LoadingBar";

export default function Home () {
    const location = useLocation();

    useEffect(() => {
        if (location.state?.targetSection) {
        scroller.scrollTo(location.state.targetSection, {
            smooth: true,
            offset: -70,
            duration: 500,
        });
        }
    }, [location]);

    return (
        <>
            <HeroSection />
            <Footer />

        </>
    )
}